// extracted by mini-css-extract-plugin
export default {"overviewItem":"OverviewItem_overviewItem__LXUkN"};